import React from "react";

const Skill = ({ skill }) => {
  const level = skill.level || 0;
  return (
    <div className="p-4 border rounded-lg shadow-sm bg-white hover:shadow-md transition-shadow">
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-semibold text-lg">{skill.name}</h3>
        {skill.category && (
          <span className={`px-2 py-1 text-xs font-semibold rounded-full ${skill.category === "Technical" ? "bg-blue-100 text-blue-800" : "bg-green-100 text-green-800"}`}>
            {skill.category}
          </span>
        )}
      </div>
      {skill.subcategory && <p className="text-sm text-gray-500 mb-2">{skill.subcategory}</p>}
      <div className="flex items-center">
        <span className="text-sm font-medium text-gray-700 mr-2">Level:</span>
        <div className="flex items-center flex-grow">
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div className="bg-indigo-600 h-2.5 rounded-full" style={{ width: `${level * 20}%` }}></div>
          </div>
        </div>
        <span className="ml-3 text-sm font-bold">{level}/5</span>
      </div>
      {skill.description && <p className="mt-3 text-sm text-gray-700 italic">"{skill.description}"</p>}
    </div>
  );
};

export default function Skills({ user }) {
  if (!user || !user.skills || user.skills.length === 0) {
    return (
      <div className="p-4 bg-white rounded-lg shadow">
        <p className="text-gray-500 italic">No skills to display.</p>
      </div>
    );
  }

  const technicalSkills = user.skills.filter((s) => s.category === "Technical");
  const softSkills = user.skills.filter((s) => s.category === "Soft");
  const otherSkills = user.skills.filter((s) => s.category !== "Technical" && s.category !== "Soft");

  return (
    <div className="flex flex-col gap-8">
      {technicalSkills.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-4">Technical Skills</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {technicalSkills.map((skill) => (
              <Skill key={skill._id} skill={skill} />
            ))}
          </div>
        </div>
      )}

      {softSkills.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-4 mt-4">Soft Skills</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {softSkills.map((skill) => (
              <Skill key={skill._id} skill={skill} />
            ))}
          </div>
        </div>
      )}

      {otherSkills.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-4 mt-4">Other Skills</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {otherSkills.map((skill) => (
              <Skill key={skill._id} skill={skill} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
} 